import { render, staticRenderFns } from "./GeneralUpdater.vue?vue&type=template&id=3a377071&"
import script from "./GeneralUpdater.vue?vue&type=script&lang=js&"
export * from "./GeneralUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports